/**
 *
 * @param {String} name
 * @returns String
 * NOTE! dont interchage the index of names and parsenames they are corrspond to each other
 */

const nameToPath = {
	accommodation: "Accommodation",
	adminformslist: "Admin Forms List",
	approvallist: "Approvals",
	categorymanagement: "Categories",
	samplecategory: "Sample Categories",
	chainofcustody: "Custodies",
	clientdocument: "Client",
	clientdocuments:"Client Document",
	clientrequests: "Client Request",
	clientformlist: "Client Form List",
	clientorders: "Client Orders",
	customreports: "Custom Report",
	dataentery: "Data Entries",
	dataentries: "Approvals",
	documents: "Laboratory",
	employeeformlist: "Employee Form List",
	
	equipments: "Equipment",
	expireditems: "Expiries",
	externalusers: "External Users",
	formbuilder: "Form Builder",
	formslist: "Form Lists",
	generalinventory: "G.Inventories",
	groups: "Authorisations",
	identification: "IDs",
	internalaudit: "Internal Audit",
	internalusers: "Internal Users",
	interlaboratoryprogram: "Inter Laboratory Program",
	intralaboratoryprogram: "Intra Laboratory Program",
	job: "My Jobs",
	joblist: "Jobs List",
	listofdocument: "Quality Managment-List Of Document",
	managegroup: "Authorisations",
	managmentreview: "Management Review",
	masterlist: "Inventory",
	methodpackages: "Method Packages",
	methods: "Methods",
	methodview: "Method View",
	multipage: "Multi Page",
	nonconformityreport: "Non Conformity Report",
	plantraining: "Plan Training",
	qmsetting: "Quality Managment Setting",
	qualitymanagment: "QMS",
	reagentsandchemicals: "Reagents",
	reportcustom: "Custom",
	["draft-report-approval"]:"Draft Report Approval",
	workorderreport:"Work Order Report",
	samplereport:"Sample Report",
	reports: "Job",
	reporttemplates: "Report Templates",
	rolesandpermissions: "Roles And Permissions",
	samplelist: "Samples Inventory",
	samplesinventory: "Sample Inventory",
	samplesname: "Sample Names",
	singlepage: "Single Page",
	sitesetting: "Corporate Profile",
	smtp: "SMTP Setting",
	subscriber: "Subscribers",
	subscriptionplan: "Subscription Plan",
	training: "Training",
	useractivity: "User Activity",
	usersetting: "Profile Setting",
	vendor: "List",
	vendrformlist: "Vendor Form List",
	workorders: "Work Orders",
	recurringsurveylist: "Recurring Survey List",
	surveys: "Survey",
	analysis: "Analysis",
	employeeevaluation: "Employee Evaluation",
	vendorevaluation: "Vendor Evaluation",
	equipmentevaluation: "Equipment Evaluation",
	clientevaluation: "Client Evaluation",
	recurringanalysis:"Recurring Survey Analysis",
	/* New requirement from client */
	projects:"Projects",
	["samples-names"]:"Sample Names",

	// phase4
	organizationprofileformlist:"Organization Profile Form List",
	publicformlist:"Public Form List",
	equipmentformlist:"Equipment Form List",
	["certified-reference-material"]:"Certified Reference Material"

};

export const pathname = (name) => {
	return decodeURI(
		name === undefined ? "Name not available" : nameToPath[name] || name,
	);
};
